//export const API_ServerAddress: string='http://api.ferdoslab.com/';
export const API_ServerAddress: string ='http://api.valiasrlab.com/';
// export const API_ServerAddress: string = 'http://api.modernviruslab.com/';
//export const API_ServerAddress: string = 'http://localhost:2241/';
//export const API_ServerAddress: string = 'http://api.dolatabadlab.ir/';
//export const API_ServerAddress: string = 'http://api.shafaghmedlab.com/';
